import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPaperClip = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.4604 4.38639C13.6836 3.60297 12.423 3.60297 11.6462 4.38639L5.7887 10.2942C4.44847 11.6459 4.44847 13.8357 5.7887 15.1874C7.12893 16.5391 9.30004 16.5391 10.6403 15.1874L15.4791 10.307C15.8261 9.95706 16.3928 9.95706 16.7398 10.307C17.0867 10.657 17.0867 11.2285 16.7398 11.5785L11.9009 16.4588C9.86351 18.5137 6.56546 18.5137 4.52805 16.4588C2.49065 14.404 2.49065 11.0776 4.52805 9.02273L10.3856 3.11494C11.8595 1.62835 14.2471 1.62835 15.721 3.11494C17.195 4.60152 17.195 7.00958 15.721 8.49616L10.1182 14.1471C9.20772 15.0654 7.7306 15.0654 6.82014 14.1471C5.90967 13.2288 5.90967 11.739 6.82014 10.8208L11.4043 6.19726C11.7513 5.84729 12.3179 5.84729 12.6649 6.19726C13.0119 6.54723 13.0119 7.11875 12.6649 7.46872L8.08078 12.0922C7.86749 12.3073 7.86749 12.6605 8.08078 12.8756C8.29407 13.0908 8.64425 13.0908 8.85754 12.8756L14.4604 7.2247C15.2372 6.44128 15.2372 5.16982 14.4604 4.38639Z",
		fill: "#0D2976"
	})
});
export default SvgPaperClip;
